<template>
  <div class="right-box2-main">
    <div class="statis-title">
      <img class="img1" src="@/assets/screen/userdata.png" alt="" />
      <span>账户支付数据分析</span>
      <div>
        <span :class="{'active': item.id === dateType}" @click="handleTabDate(item.id)" v-for="(item,index) in dayData" :key="index">{{item.name}}</span>
      </div>
    </div>
    <div class="cake-box">
      <pancake-vue :echart-data="echartData" echartName="echarts" :type="1" />
      <pancake-vue :echart-data="echartData1" echartName="echarts1" :type="2" />
    </div>
  </div>
</template>

<script>
import homeStatisticsApi from '@/api/home'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import { timeForMat } from '@/utils/index'
import pancakeVue from './pancake.vue'
export default {
  components: { pancakeVue },
  data() {
    return {
      dateType: 4,
      dayData: [
        // { id: 1, name: '今天' }, { id: 2, name: '昨天' }, 
        { id: 3, name: '最近7天' }, { id: 4, name: '最近1个月' }],
      startTime: '',
      endTime: '',
      yAxisData: [],
      yAxisData1: []
    }
  },
  created() {
    this.startTime = timeForMat('6')[0]
    this.endTime = timeForMat('6')[1]
    this.getTechnicianService()
    this.getAccountAnalysis()
  },
  methods: {
    //账户支出分析
    getAccountAnalysis() {
      let params = {
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59'
      }
      DataBoardApi.findAccountStatisticsByBigSereenVO(params).then(({ data }) => {
        if (data.length > 0) {
          // 支付方式1零售价支付2余额账户支付3积分账户支付4赠送账户支付
          let find1 = data.find(item => item.orderPayType === 1)
          let find2 = data.find(item => item.orderPayType === 2)
          let find3 = data.find(item => item.orderPayType === 3)
          let find4 = data.find(item => item.orderPayType === 4)
          this.yAxisData = [{ value: find2 ? find2.payMoney : 0, name: '余额账户', itemStyle: { color: '#5CDAF5' } },
          { value: find1 ? find1.payMoney : 0, name: '零售价账户', itemStyle: { color: '#129BFF' } },
          { value: find4 ? find4.payMoney : 0, name: '赠送账户', itemStyle: { color: '#D048DC' } },
          { value: find3 ? find3.payMoney : 0, name: '积分账户', itemStyle: { color: '#FFCF5F' } }]
        }

      })
    },
    //技术服务老师
    getTechnicianService() {
      let params = {
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
      }
      homeStatisticsApi.technicianServiceOrderStatistics(params).then(res => {
        let { onlinePercen, offlinePercen } = res.data;
        this.yAxisData1 = [{ value: onlinePercen || 0, name: '线上预约', itemStyle: { color: '#5CDAF5' } },
        { value: offlinePercen || 0, name: '线下预约', itemStyle: { color: '#4120E6' } }]
      })
    },
    handleTabDate(type) {
      if (this.dateType === type) return
      this.dateType = type;
      // if (type === 1) {
      //   this.startTime = timeForMat('0')[0]
      //   this.endTime = timeForMat('0')[0]
      // } else if (type === 2) {
      //   this.startTime = timeForMat('1')[0]
      //   this.endTime = timeForMat('1')[0]
      // } else 
      if (type === 3) {
        this.startTime = timeForMat('6')[0]
        this.endTime = timeForMat('6')[1]
      } else if (type === 4) {
        this.startTime = timeForMat('29')[0]
        this.endTime = timeForMat('29')[1]
      }
      this.getTechnicianService()
      this.getAccountAnalysis()
    },

  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        legendData: ["余额账户", "零售价账户", "赠送账户", "积分账户"],
        yAxisData: this.yAxisData
      };
    },
    echartData1() {
      return {
        // legendData: item.dataList.map(it => it.title),
        legendData: ["线上预约", "线下预约"],
        yAxisData: this.yAxisData1
      };
    },
  }
}
</script>
<style lang="scss" scoped>
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}
@mixin fontColor($fonsSize, $color) {
  font-size: $fonsSize;
  color: $color;
}
.right-box2-main {
  .statis-title {
    display: flex;
    align-items: center;
    position: relative;
    span {
      @include fontColor(16px, #fff);
      padding: 0 10px 0 8px;
    }
    .img1 {
      @include wh(24px, 24px);
    }
    .hint {
      @include wh(13px, 13px);
      cursor: pointer;
    }
    div {
      position: absolute;
      right: 0;
      span {
        padding: 0 12px;
        @include fontColor(16px, #fff);
        cursor: pointer;
        &.active {
          background-color: #5a5a89;
          padding: 5px 10px;
          border-radius: 30px;
        }
      }
    }
  }
}
.cake-box {
  display: flex;
  margin-top: 25px;
}
</style>
